// frontend/src/components/shared/Toast.jsx
// Small self-dismissing notification — replaces browser alert() popups.
import { useState, useRef, useCallback } from 'react';
import { colors, fontFamily } from '../../theme';

export function useToast() {
  const [toast, setToast] = useState(null); // { message, type: 'success' | 'error' }
  const timerRef = useRef(null);
  const showToast = useCallback((message, type = 'success') => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ message, type });
    timerRef.current = setTimeout(() => setToast(null), 2200);
  }, []);
  return { toast, showToast };
}

export default function ToastHost({ toast }) {
  if (!toast) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 200,
        padding: '0.75rem 1rem',
        borderRadius: 8,
        maxWidth: '90vw',
        textAlign: 'center',
        fontSize: '0.85rem',
        fontWeight: 600,
        fontFamily,
        background: colors.bgGradient,
        boxShadow: colors.shadowRaised,
        color: colors.textPrimary,
        border: `1px solid ${toast.type === 'error' ? colors.negative : colors.odds}`,
      }}
    >
      {toast.message}
    </div>
  );
}
